/* ActionTypes */
import { FETCH_PAGE_BY_ID } from './actionTypes';

/* Utils */
import { generateRequestActionCreator } from '../utils/generators/actionGenerators';

export const fetchPageById = generateRequestActionCreator((pageId, sourceProvider, sportIds) => ({
  type: FETCH_PAGE_BY_ID,
  payload: { pageId, sourceProvider, sportIds },
}));
